const map = {
	"./animal.svg": "./src/images/animal.svg",
	"./arrow-down.svg": "./src/images/arrow-down.svg?271c",
	"./arrow.svg": "./src/images/arrow.svg",
	"./bicycle.svg": "./src/images/bicycle.svg",
	"./boat.svg": "./src/images/boat.svg",
	"./bus.svg": "./src/images/bus.svg",
	"./car.svg": "./src/images/car.svg",
	"./crane.svg": "./src/images/crane.svg",
	"./cross.svg": "./src/images/cross.svg?652c",
	"./default.svg": "./src/images/default.svg",
	"./helicopter.svg": "./src/images/helicopter.svg",
	"./motorcycle.svg": "./src/images/motorcycle.svg",
	"./offroad.svg": "./src/images/offroad.svg",
	"./person.svg": "./src/images/person.svg",
	"./pickup.svg": "./src/images/pickup.svg",
	"./plane.svg": "./src/images/plane.svg",
	"./right-arrow.svg": "./src/images/right-arrow.svg?ab68",
	"./ship.svg": "./src/images/ship.svg",
	"./tick.svg": "./src/images/tick.svg?7b45",
	"./tractor.svg": "./src/images/tractor.svg",
	"./train.svg": "./src/images/train.svg",
	"./tram.svg": "./src/images/tram.svg",
	"./trolleybus.svg": "./src/images/trolleybus.svg",
	"./truck.svg": "./src/images/truck.svg",
	"./van.svg": "./src/images/van.svg"
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/images sync \\.(png%7Cjpe%3Fg%7Csvg)$";